// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pingId: __t.u64().primaryKey().name("ping_id"),
  partyId: __t.u64().name("party_id"),
  sender: __t.identity(),
  kind: __t.string(),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  targetKey: __t.string().name("target_key"),
  parentId: __t.u64().name("parent_id"),
  expiresAt: __t.timestamp().name("expires_at"),
  at: __t.timestamp(),
});
